import { AutomationType } from '@/shared/types';
import { Calendar, Webhook } from 'lucide-react';

interface AutomationTypeBadgeProps {
  type: AutomationType;
  showIcon?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export function AutomationTypeBadge({
  type,
  showIcon = true,
  size = 'md',
}: AutomationTypeBadgeProps) {
  const isScheduler = type === AutomationType.CRON;
  const label = isScheduler ? 'Scheduler' : 'Event';
  const Icon = isScheduler ? Calendar : Webhook;

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-3.5 w-3.5',
    lg: 'h-4 w-4',
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md font-medium ${sizeClasses[size]} ${
        isScheduler
          ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400'
          : 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400'
      }`}
    >
      {showIcon && <Icon className={iconSizes[size]} />}
      {label}
    </span>
  );
}
